/* eslint-disable max-len */
import React from 'react';

interface HideProps {
    color?: string;
}

const Hide: React.FC<HideProps> = ({color='#616E6E'}) => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.47436 11.5819C1.17978 11.822 0.744973 11.8047 0.470453 11.5301C0.196079 11.2556 0.178632 10.8207 0.418695 10.5262L0.470453 10.4696L1.82983 9.11119C0.943122 8.21289 0.34472 7.17635 0.0515075 6.45201C-0.0171839 6.28237 -0.0171544 6.09236 0.0515075 5.92271C0.361957 5.15579 1.01429 4.04068 1.98901 3.10631C2.97017 2.16542 4.31863 1.37498 6.0017 1.37486C7.06448 1.37491 7.99349 1.69081 8.781 2.16002L10.4705 0.469587C10.7633 0.176749 11.2381 0.176859 11.531 0.469587C11.8239 0.762481 11.8239 1.23724 11.531 1.53013L1.531 11.5301L1.47436 11.5819ZM4.10619 6.83482C4.09431 6.79761 4.08001 6.76084 4.07006 6.72252C3.7847 5.62266 4.41867 4.49065 5.4851 4.19615C5.89802 4.08226 6.3152 4.11173 6.68823 4.25279L7.45678 3.48424C7.01529 3.23151 6.51562 3.09366 6.0017 3.09361C5.20628 3.09372 4.44311 3.41988 3.88061 3.99986C3.31814 4.58003 3.0017 5.36695 3.0017 6.18736C3.00171 6.68513 3.11947 7.17001 3.33666 7.60435L4.10619 6.83482Z"
                fill={color}
            />
            <path
                d="M6.0017 10.9999C5.40324 10.9998 4.84697 10.8985 4.33471 10.7274L5.78979 9.27232C5.8599 9.27743 5.93096 9.2811 6.0017 9.28111C6.79715 9.28104 7.56027 8.95485 8.1228 8.37486C8.68535 7.79469 9.00169 7.00782 9.0017 6.18736C9.0017 6.14657 8.99838 6.1059 8.99682 6.06529L10.9226 4.13951C11.4045 4.78417 11.7493 5.42627 11.949 5.92271C12.0177 6.09244 12.0177 6.28228 11.949 6.45201C11.6405 7.21895 10.989 8.33629 10.0144 9.26842C9.03322 10.2093 7.68478 10.9998 6.0017 10.9999Z"
                fill={color}
            />
        </svg>
    );
};

export default Hide;